var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.makeupLessonItemsV1 = {
    attach: function (context, settings) {
      var $tmpls = $('.makeup-lessons-items', context);
      var isMobile = $('body').hasClass('device-mobile'); // I think there's a better way to do this

      $tmpls.each(function () {
        var $me = $(this);
        var $thumbs = $('.makeup-lessons-items__thumbs', $me);
        var $lessonTitle = $('.js-lesson-link', $me);
        var firstLessonLink = $('.makeup-lessons-item__lesson', $me).eq(0).find('a').attr('href');

        $thumbs.slick({
          rtl: site.direction.isRTL,
          dots: true,
          infinite: false,
          speed: 500,
          fade: true,
          slide: '.makeup-lessons-item',
          nextArrow: '',
          prevArrow: '',
          cssEase: 'linear'
        });

        $lessonTitle.once().on('click', function (e) {
          e.preventDefault();
          window.location.href = firstLessonLink;
        });
      });
    }
  };
})(jQuery);
